"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBSCRIPTION_ENTERPRISE_ANNUAL = exports.SUBSCRIPTION_ENTERPRISE_MONTHLY = exports.SUBSCRIPTION_PRO_ANNUAL = exports.SUBSCRIPTION_PRO_MONTHLY = exports.SUBSCRIPTION_TRIAL = exports.SUBSCRIPTION_PRIVATE = exports.genPrivateSubscription = exports.SubscriptionStruct = exports.SubscriptionTypeEnums = void 0;
const superstruct_1 = require("superstruct");
const Timestamp_1 = require("../utils/Timestamp");
exports.SubscriptionTypeEnums = (0, superstruct_1.enums)([
    'private',
    'trial',
    'pro_monthly',
    'pro_annual',
    'enterprise_monthly',
    'enterprise_annual',
]);
exports.SubscriptionStruct = (0, superstruct_1.object)({
    id: (0, superstruct_1.string)(),
    placeId: (0, superstruct_1.string)(),
    prolongAt: (0, superstruct_1.optional)(Timestamp_1.TimestampStruct),
    type: (0, superstruct_1.defaulted)(exports.SubscriptionTypeEnums, 'private'),
    cancelAt: (0, superstruct_1.optional)(Timestamp_1.TimestampStruct),
    createdAt: (0, superstruct_1.optional)(Timestamp_1.TimestampStruct),
});
function genPrivateSubscription(id) {
    return {
        id,
        type: 'private',
    };
}
exports.genPrivateSubscription = genPrivateSubscription;
exports.SubscriptionStruct.type = 'Subscription';
exports.SUBSCRIPTION_PRIVATE = 'private';
exports.SUBSCRIPTION_TRIAL = 'trial';
exports.SUBSCRIPTION_PRO_MONTHLY = 'pro_monthly';
exports.SUBSCRIPTION_PRO_ANNUAL = 'pro_annual';
exports.SUBSCRIPTION_ENTERPRISE_MONTHLY = 'enterprise_monthly';
exports.SUBSCRIPTION_ENTERPRISE_ANNUAL = 'enterprise_annual';
//# sourceMappingURL=subscription.js.map